import React from "react";

const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };

const COLUMNS = [
	[
		{
			quote: "The customer service feels personal. They understand how local businesses operate.",
			name: "Ifeanyi K.",
			role: "Auto Parts Dealer, Aba",
		},
		{
			quote: "I use the Zikora MFB app almost every day for transfers and managing payments from customers. It saves me time, reduces stress, and lets me focus more on running my shop instead of banking queues.",
			name: "Adaeze C.",
			role: "Fashion Entrepreneur, Onitsha",
		},
	],
	[
		{
			quote: "Running a business means money needs can come up at any time. Zikora MFB made it easy for me to access support when I needed to restock, and the process was faster than I expected. It has helped me keep my business growing.",
			name: "Chinedu O.",
			role: "Electronics Trader, Nnewi",
		},
		{
			quote: "I use the app for transfers daily. It saves me time and keeps my business moving.",
			name: "Obinna L.",
			role: "Spare Parts Dealer, Aba",
		},
	],
	[
		{
			quote: "The Z-ForHer credit helped me grow my catering business without pressure.",
			name: "Ngozi M.",
			role: "Food Vendor, Awka",
		},
		{
			quote: "They understand local businesses and their service feels personal.",
			name: "Uche F.",
			role: "Boutique Owner, Owerri",
		},
	],
];

const MOBILE_COLUMNS = [
	[
		{
			quote: "The customer service feels personal. They understand how local businesses operate.",
			name: "Ifeanyi K.",
			role: "Auto Parts Dealer, Aba",
		},
		{
			quote: "I use the Zikora MFB app almost every day for transfers and managing payments from customers. It saves me time, reduces stress, and lets me focus more on running my shop instead of banking queues.",
			name: "Adaeze C.",
			role: "Fashion Entrepreneur, Onitsha",
		},
	],
	[
		{
			quote: "Running a business means money needs can come up at any time. Zikora MFB made it easy for me to access support when I needed to restock, and the process was faster than I expected. It has helped me keep my business growing.",
			name: "Chinedu O.",
			role: "Electronics Trader, Nnewi",
		},
		{
			quote: "The Z-ForHer credit helped me grow my catering business without pressure.",
			name: "Ngozi M.",
			role: "Food Vendor, Awka",
		},
	],
];

const Avatar = () => (
	<div
		style={{
			width: "43px",
			height: "43px",
			borderRadius: "50%",
			backgroundColor: "#132A22",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			flexShrink: 0,
		}}
	>
		<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="12" cy="8.5" r="3.5" fill="white" />
			<path d="M4 20c0-4.418 3.582-8 8-8s8 3.582 8 8" stroke="white" strokeWidth="1.5" strokeLinecap="round" fill="none" />
		</svg>
	</div>
);

const Card = ({ quote, name, role, compact }) => (
	<div
		style={{
			backgroundColor: "#FFFFFF",
			borderRadius: "16px",
			padding: compact ? "16px" : "clamp(20px, 2.08vw, 30px)",
			display: "flex",
			flexDirection: "column",
			gap: compact ? "24px" : "clamp(40px, 7.64vw, 110px)",
		}}
	>
		<p
			style={{
				fontFamily: "'Geist', sans-serif",
				fontWeight: 400,
				fontSize: compact ? "13px" : "clamp(13px, 1.11vw, 16px)",
				lineHeight: "1.625",
				color: "#132A22",
				margin: 0,
			}}
		>
			{quote}
		</p>

		<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
			<Avatar />
			<div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
				<span
					style={{
						fontFamily: "'Geist', sans-serif",
						fontWeight: 500,
						fontSize: compact ? "13px" : "clamp(13px, 1.11vw, 16px)",
						lineHeight: "1.2",
						color: "#132A22",
					}}
				>
					{name}
				</span>
				<span
					style={{
						fontFamily: "'Geist', sans-serif",
						fontWeight: 400,
						fontSize: compact ? "12px" : "clamp(12px, 1.11vw, 16px)",
						lineHeight: "1.2",
						color: "#5E5E5E",
					}}
				>
					{role}
				</span>
			</div>
		</div>
	</div>
);

const Testimonials = () => {
	return (
		<>
			<style>{`
				@media (max-width: 767px) {
					.testimonials-section {
						padding: 40px 18px !important;
					}
					.testimonials-heading-block {
						align-items: center !important;
						text-align: center !important;
					}
					.testimonials-heading {
						font-size: 32px !important;
						font-weight: 400 !important;
						text-align: center !important;
						max-width: 343px !important;
						line-height: 40px !important;
					}
					.testimonials-subtitle {
						font-size: 14px !important;
						text-align: center !important;
						max-width: 313px !important;
						line-height: 26px !important;
					}
					.testimonials-desktop-grid { display: none !important; }
					.testimonials-mobile-grid  { display: flex !important; }
				}
				.testimonials-mobile-grid { display: none; }
			`}</style>

			<section
				className="testimonials-section"
				style={{
					width: "100%",
					background: "linear-gradient(180deg, #FFFFFF 0%, #F6F4EE 39.64%)",
					boxSizing: "border-box",
					padding: "clamp(48px, 6.94vw, 100px) clamp(20px, 15.14vw, 218px)",
				}}
			>
				<div
					style={{
						maxWidth: "1004px",
						margin: "0 auto",
						display: "flex",
						flexDirection: "column",
						gap: "clamp(24px, 2.78vw, 40px)",
					}}
				>
					{/* Heading block */}
					<div
						className="testimonials-heading-block"
						style={{
							display: "flex",
							flexDirection: "column",
							gap: "8px",
							alignItems: "center",
							textAlign: "center",
						}}
					>
						{/* Label */}
						<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
							<span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#295B4A", flexShrink: 0, display: "inline-block" }} />
							<span
								style={{
									...geistMono,
									fontWeight: 500,
									fontSize: "12px",
									lineHeight: "1",
									letterSpacing: "0.08em",
									color: "#295B4A",
									textTransform: "uppercase",
									whiteSpace: "nowrap",
								}}
							>
								Trusted by Traders &amp; Entrepreneurs
							</span>
						</div>

						<h2
							className="testimonials-heading"
							style={{
								...instrumentSerif,
								fontWeight: 400,
								fontSize: "clamp(32px, 4.17vw, 60px)",
								lineHeight: "1.1",
								letterSpacing: "-0.01em",
								color: "#132A22",
								margin: 0,
								maxWidth: "837px",
							}}
						>
							What our customers are saying about Zikora
						</h2>
						<p
							className="testimonials-subtitle"
							style={{
								fontFamily: "'Geist', sans-serif",
							fontWeight: 400,
							fontSize: "clamp(15px, 1.39vw, 20px)",
							lineHeight: "1.6",
							color: "#5E5E5E",
							margin: 0,
							maxWidth: "708px",
							}}
						>
							From traders to entrepreneurs, Zikora helps everyday people move forward.
						</p>
					</div>

					{/* Desktop 3-column grid */}
					<div
						className="testimonials-desktop-grid"
						style={{
							display: "flex",
							gap: "clamp(10px, 1.11vw, 16px)",
							alignItems: "flex-start",
						}}
					>
						{COLUMNS.map((column, colIdx) => (
							<div
								key={colIdx}
								style={{
									flex: 1,
									minWidth: 0,
									display: "flex",
									flexDirection: "column",
									gap: "clamp(10px, 1.11vw, 16px)",
								}}
							>
								{column.map((item, idx) => (
									<Card key={idx} {...item} />
								))}
							</div>
						))}
					</div>

					{/* Mobile 2-column grid */}
					<div
						className="testimonials-mobile-grid"
						style={{
							gap: "12px",
							alignItems: "flex-start",
						}}
					>
						{MOBILE_COLUMNS.map((column, colIdx) => (
							<div
								key={colIdx}
								style={{
									flex: 1,
									minWidth: 0,
									display: "flex",
									flexDirection: "column",
									gap: "12px",
								}}
							>
								{column.map((item, idx) => (
									<Card key={idx} {...item} compact />
								))}
							</div>
						))}
					</div>
				</div>
			</section>
		</>
	);
};

export default Testimonials;
